import { FaCrown, FaPlus } from "react-icons/fa";

export const plans = {
  free: {
    name: "free",
    description: "간편한 것들만 모아서",
    monthlyPrice: 0,
    features: ["일정 관리", "프로젝트 관리", "모임 기능 제공", "개인 도메인"],
    label: "무료로 시작하기",
  },
  plus: {
    name: "plus",
    description: "시작하는 사장님들은",
    addDescription: "기업 홈페이지를 단, 3초만에!\n새로 시작하는 사장님들을 위한 서비스입니다.",
    price: 10000,
    monthlyPrice: 4500,
    features: [
      "FREE의 모든 기능 포함",
      "모노티 플랫폼 입점",
      "매장 홍보 지원",
      "웹 결제 시스템 제공",
    ],
    label: "플러스",
    icon: FaPlus,
  },
  premium: {
    name: "premium",
    description: "상생매장 사장님들을 위한",
    addDescription: "오더부터 결제까지, 주문을 편하게!\n상생매장 사장님들을 위한 서비스입니다.",
    price: 20000,
    monthlyPrice: 9900,
    features: ["FREE와 PLUS의 모든 기능 포함", "픽업 오더", "매출 분석 리포트", "실시간 알림 발송"],
    label: "프리미엄",
    icon: FaCrown,
  },
};

export const subscription = {
  tiers: Object.values(plans).map(({ name, price, monthlyPrice }) => ({
    tier: name,
    price: price
      ? {
          original: `${formatNumber(price)}원/월`,
          discounted: `${formatNumber(monthlyPrice)}원/월`,
        }
      : 0,
  })),
  features: [
    { name: "일정 관리", tiers: ["free", "plus", "premium"] },
    { name: "프로젝트 관리", tiers: ["free", "plus", "premium"] },
    { name: "모임 기능 제공", tiers: ["free", "plus", "premium"] },
    { name: "개인 도메인", tiers: ["free", "plus", "premium"] },
    { name: "모노티 플랫폼 입점", tiers: ["plus", "premium"] },
    { name: "매장 홍보", tiers: ["plus", "premium"] },
    { name: "웹 결제 시스템", tiers: ["plus", "premium"] },
    { name: "픽업 오더", tiers: ["premium"] },
    { name: "매출 분석 리포트", tiers: ["premium"] },
    { name: "실시간 알림 발송", tiers: ["premium"] },
  ],
};
